import { DocumentType } from '@/apis/datastore/model'

// import ParagraphListItem from './CommonParagraphListItem'
import type { NormalParagraphListItemProps } from './NormalParagraphListItem'
import NormalParagraphListItem from './NormalParagraphListItem'

import QAparagraphListItem from './QAParagraphListItem'

export * from './CommonParagraphListItem'

export default (
  props: NormalParagraphListItemProps & { file_type?: DocumentType },
) => {
  if (props.file_type === DocumentType.QA) {
    return <QAparagraphListItem {...props} />
  }
  return <NormalParagraphListItem {...props} />
}
